import API from './api';

export default class Box extends API {
  constructor(config = {}) {
    config.path = 'boxes';

    super(config);
  }

  metrics(resource = '', params = {}) {
    return this.get(`${resource}/metrics`, params);
  }

  resume(resource = '', params = {}) {
    return this.get(`${resource}/summary`, params);
  }

  resumeEmails(resource = '', params = {}) {
    return this.get(`${resource}/summary/emails`, params);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/box.js
 **/